<template>
  <div>
    LADEBALKEN
  </div>
</template>

<script>

export default {
  name: "",
  data: () => ({
  }),
  mounted() {
  },
  computed: {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style scoped>
</style>
